import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { VueMaskDirective } from "v-mask";
import { makeServer } from "./server";
// Por que foi comentado?
// import Init from "./services/init";
import VueMoment from 'vue-moment';
import ApiHttpClient from '@/core/api-http-client';
import VueClipboard from 'vue-clipboard2';
import { ApmVuePlugin } from '@elastic/apm-rum-vue';
import './assets/scss/app.scss';

if (process.env.NODE_ENV === "development") {
  makeServer()
}
Vue.config.productionTip = false;
Vue.directive("mask", VueMaskDirective);
Vue.use(VueMoment);
Vue.use(VueClipboard);
Vue.use(ApmVuePlugin, {
  config: {
    serviceName: 'prd-troca-de-chip',  // Nome do serviço
    serverUrl: 'https://bf5f338d91234ee083ba18655002de64.apm.eastus2.azure.elastic-cloud.com:443', // URL do servidor APM prd
    //serverUrl: 'https://1e74788fcdc847b4aa6a9c2478cc097f.apm.eastus2.azure.elastic-cloud.com:443', //URL do servidor APM fqa
    
    environment: 'prd',
  },
  router,  // Passando o Vue Router para capturar mudanças de rota
  transaction: {
    pageLoad: true,  // Monitoramento do carregamento da página
    routeChange: true,  // Monitoramento de mudanças de rota
  }
});



ApiHttpClient.setModifier((options) => {
  const apiOptions = {};

  if (process.env.NODE_ENV === "development") {
    apiOptions.baseURL = '/api/changechip';
  } else {
    apiOptions.baseURL = '/changechip';
  }

  apiOptions.headers = {
    access_key: store.getters.getAccessKey,
    metadata: store.getters.getMetadataCookie
  };

  return {...options, ...apiOptions};
});

// Por que foi comentado?
// Init.start();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');